import { render, staticRenderFns } from "./InventarisDetail.vue?vue&type=template&id=235bd459"
import script from "./InventarisDetail.vue?vue&type=script&lang=js"
export * from "./InventarisDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports